import { drawPath, paths } from "./Utils.js";
export class SpadeDrawer {
    constructor() {
        this.validTypes = ["spade", "spades"];
    }
    draw(data) {
        drawPath(data, paths.spade);
    }
}
